import React from 'react';
import { useSelector } from '../../../hooks';

const TemplateBased = ({
  templates = [],
  allTemplates,
  templateId,
  children,
}) => {
  const userSite = useSelector('userSite');
  const _templateId = userSite?.data?.template?._id || templateId;

  const shouldRender =
    templates.includes(_templateId) ||
    templates.length === 0 ||
    allTemplates ||
    process.env.NODE_ENV === 'development';

  return shouldRender
    ? // Pass the 'templateId' as props to all of the one level children components implicitly.
      React.Children.map(children, (child) => {
        if (typeof child.type === 'string') {
          return child;
        }
        const newChild = React.cloneElement(child, { templateId: _templateId });
        return newChild;
      })
    : null;
};

export default TemplateBased;
